import * as LoanApplicationActions from '../../../actions/LoanApplicationActions';
import * as WizardActions from '../../../actions/WizardActions';
import * as UIActions from '../../../actions/UIActions';
import {defaultState} from '../../state';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as ValidateConstant from '../../../constants/ValidateConstant';
import {FieldApplicantSummary, WorkApplicantSummaryDTO} from '../../../types/mx/creditoReal/epics';
import {WorkDataStepViewErrorFieldState} from '../../../types/mx/creditoReal/reducers';

const workDataStepView = (state = defaultState.creditoReal.ui.workDataStepView, action) => {
    switch (action.type) {
        case LoanApplicationActions.CLEAN_LOAN_APPLICATION_DATA_ACTION.name:
            return {
                ...state,
                hasPostalCodeError: false,
            };
        case LoanApplicationActions.ERROR_GOT_LOCATIONS_ACTION.name:
            return {
                ...state,
                hasPostalCodeError: true,
            };
        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_NAME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    workplaceNameFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_POSITION_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    positionFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_WORKING_SINCE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    workingSinceFieldError: action.error
                }
            };

        case WizardActions.CHANGE_EMPLOYMENT_DOCUMENT_TYPE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    documentTypeFieldError: action.error
                }
            };

        case WizardActions.CHANGE_EMPLOYMENT_BUSINESS_TYPE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    businessTypeFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_TYPES_INCOMES.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    relationshipTypeIdFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_BILLING_TYPE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    billingTypeFieldError: action.error,
                    taxRegimeFieldError: action.billingType.id === 'TAX'
                        ? ValidateConstant.ERROR_REQUIRED
                        : defaultState.creditoReal.ui.workDataStepView.fieldErrors.taxRegimeFieldError,
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_TAX_REGIME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    taxRegimeFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_ADDRESS_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    addressFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_EXT_NUMBER_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    extNumberFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_INT_NUMBER_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    intNumberFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    postalCodeFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    workplacePhoneFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_COLONY_MX_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    selectedColonyFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    workplacePhoneExtError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_MONTHLY_INCOMES_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    monthlyIncomesFieldError: action.error
                }
            };
        case WizardActions.CHANGE_INCLUDE_MONTHLY_INCOMES.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    monthlyIncomesFieldError: action.includeMonthlyIncomes ?
                        state.fieldErrors.monthlyIncomesFieldError ?
                            state.fieldErrors.monthlyIncomesFieldError : action.monthlyIncomes ?
                            null :ValidateConstant.ERROR_REQUIRED : null
                }
            };

        case WizardMXActions.NOT_FOUND_LOCATION_ERROR_MX_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    postalCodeFieldError: ValidateConstant.ERROR_POSTAL_CODE,
                    stateFieldError: ValidateConstant.ERROR_REQUIRED,
                    cityFieldError: ValidateConstant.ERROR_REQUIRED,
                    municipalityFieldError: ValidateConstant.ERROR_REQUIRED,
                    selectedColonyFieldError: ValidateConstant.ERROR_REQUIRED
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_STATES_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    stateFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_CITY_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    cityFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_MUNICIPALITY_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    municipalityFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_COLONIES_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    selectedColonyFieldError: action.error
                }
            };
        case WizardMXActions.SET_EMPLOYMENT_DATA_STATE_ACTION.name:
            const fieldSummary: FieldApplicantSummary<WorkApplicantSummaryDTO, WorkDataStepViewErrorFieldState>
                = action.fieldSummary;
            return {
                ...state,
                fieldErrors: fieldSummary.fieldErrors
            };
        case UIActions.CLEAN_STATE_ACTION.name:
        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.name:
            return defaultState.creditoReal.ui.workDataStepView;
        default:
            return state;
    }
};

export default workDataStepView;
